export default {
    data: [],
    fetched: false,
    formName: "",
};